import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type LockIconProps = MergeWithOverwrite<
  React.HtmlHTMLAttributes<HTMLSpanElement>,
  {
    width?: number;
    height?: number;
    color?: string;
  }
>;

export const LockIcon: React.FC<LockIconProps> = ({
  width = 12,
  height = 8,
  color = colors.primary,
  ...props
}) => (
  <IconSpan {...props} height={height} width={width}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="lock 1">
        <g id="XMLID_509_">
          <path
            id="XMLID_510_"
            d="M3.57497 11H10.1865C10.4604 11 10.6824 10.7965 10.6824 10.5455V5.39394C10.6824 5.14291 10.4604 4.93939 10.1865 4.93939H9.69067V3.57576C9.69067 2.15548 8.43014 1 6.88075 1C5.33137 1 4.07084 2.15548 4.07084 3.57576V4.93939H3.57497C3.30112 4.93939 3.0791 5.14291 3.0791 5.39394V10.5455C3.0791 10.7965 3.30112 11 3.57497 11ZM7.37662 8.12079V8.72727C7.37662 8.9783 7.15461 9.18182 6.88075 9.18182C6.6069 9.18182 6.38489 8.9783 6.38489 8.72727V8.12079C6.18429 7.98245 6.05431 7.76249 6.05431 7.51515C6.05431 7.09742 6.42505 6.75758 6.88075 6.75758C7.33646 6.75758 7.7072 7.09742 7.7072 7.51515C7.7072 7.76249 7.57722 7.98245 7.37662 8.12079ZM5.06257 3.57576C5.06257 2.65676 5.87821 1.90909 6.88075 1.90909C7.8833 1.90909 8.69894 2.65676 8.69894 3.57576V4.93939H5.06257V3.57576Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  </IconSpan>
);
